// Auto-generated from vcs-connections domain registry

export enum VcsConnectionEventNames {
  CONNECT = "vcs_connection.connect",
  DISCONNECT = "vcs_connection.disconnect",
  CREATE_REPO = "vcs_connection.create_repo",
  CONNECTED = "vcs_connection.connected",
  DISCONNECTED = "vcs_connection.disconnected",
  REPO_CREATED = "vcs_connection.repo_created",
  ERROR = "vcs_connection.error",
}

export enum VcsConnectionEndpoints {
  LIST = "/api/v1/vcs-connections",
  CREATE = "/api/v1/vcs-connections",
  DELETE = "/api/v1/vcs-connections/:id",
  WEBHOOK_GITHUB = "/api/v1/vcs-connections/webhooks/github",
  WEBHOOK_GITLAB = "/api/v1/vcs-connections/webhooks/gitlab",
  GITLAB_AUTH_URL = "/api/v1/vcs-connections/gitlab/auth-url",
  GITLAB_OAUTH_CALLBACK = "/api/v1/vcs-connections/gitlab-oauth-callback",
}

export type VcsProvider = "github" | "gitlab";

export interface VcsConnectionSummary {
  id: number;
  provider: VcsProvider;
  providerOrgName: string;
  status: "connected" | "disconnected" | "error";
  installedBy: number;
  createdAt: string;
  updatedAt: string;
  gitlabGroupId?: number;
}
